export const stateToComponentMap = {
  merged: 'mr-widget-merged',
  closed: 'mr-widget-closed',
  merging: 'mr-widget-merging',
  missingBranch: 'mr-widget-missing-branch',
  readyToMerge: 'mr-widget-ready-to-merge',
  nothingToMerge: 'mr-widget-nothing-to-merge',
  archived: 'mr-widget-archived',
  preparing: 'mr-widget-preparing',
  pipelineFailed: 'mr-widget-pipeline-failed',
  shaMismatch: 'sha-mismatch',
  mergeChecksFailed: 'mergeChecksFailed',
};

export const stateKey = {
  archived: 'archived',
  missingBranch: 'missingBranch',
  nothingToMerge: 'nothingToMerge',
  preparing: 'preparing',
  pipelineFailed: 'pipelineFailed',
  shaMismatch: 'shaMismatch',
  readyToMerge: 'readyToMerge',
  merging: 'merging',
  merged: 'merged',
  mergeChecksFailed: 'mergeChecksFailed',
};
